<div class="files-preview-block">
  @for (item of files; track item) {
    <div class="img-container" (click)="previewClick(item)">
      @if (item?.previewImage) {
        <img [src]="item.previewImage" />
      }
      @if (!item?.previewImage) {
        <div class="spinner"></div>
      }
    </div>
  }
</div>
